import { DeleteIcon } from '@chakra-ui/icons'
import {
  VStack,
  StackDivider,
  Box,
  HStack,
  Spacer,
  IconButton,
} from '@chakra-ui/react'
import { useContext, useState } from 'react'

import { AppContext } from '../../libs/context'
import { IModel } from '../../type/modelType'
import { deleteModel, listModels } from '../../utils/modelEngine/configuration'

export default function () {
  const context = useContext(AppContext)
  const { model } = context

  const [models, setModels] = useState<IModel[]>(listModels(context))

  return (
    <VStack
      divider={<StackDivider borderColor="gray.200" />}
      spacing={4}
      align="stretch"
    >
      {models.map(m => (
        <HStack>
          <Box maxW="200px" overflowX="hidden" justifyContent="left">
            {m.id}
          </Box>
          <Spacer />
          <IconButton
            aria-label="Search database"
            icon={<DeleteIcon />}
            onClick={() => {
              deleteModel(m.id, context).then(() => {
                setModels(listModels(context))
                if (m.id === model.current.id) {
                  document.location.replace('/')
                }
              })
            }}
          />
        </HStack>
      ))}
    </VStack>
  )
}
